<template>
<div>
    <Loading v-if="loadMask"/>
    <div class="script-list">
        <div class="search-tag-wrap">
            <ul class="tag-box one-level-tag">
                <li :style="isAllActiveOne?'color:#bf0000;font-weight:bold;':''" 
                    @click="allActiveOne"
                >
                全部
                </li>
                <li v-for="(item,index) in oneCateList" 
                    :key="index" 
                    :data-role="item&&item.id"
                    @click="selOnecateTag($event,index)" 
                    :class="oneActiveClass==index?'one-active':''"
                >
                    {{item&&item.name}}
                </li>
            </ul>
            <div class="search-wrap">
                <ul class="tag-box">
                    <li :style="isAllActiveTwo?'color:#bf0000;font-weight:bold;':''" 
                        @click="allActiveTwo"
						style="padding-right:20px;"
                    >
                    全部
                    </li>
					<swiper :options="ListPageSwiperOption">
						<swiper-slide v-for="(item,index) in twoCateList" :key="index">
							<li :key="index"
								:data-role="item&&item.id"
								:class="item.id==fromeHomeTagSearch?'one-active':''"
								@click="selTwocateTag($event)" 
								ref="twoCateTag"
								style="padding-left:0;padding-right:0"
							>
								{{item&&item.name}}
							</li> 
						</swiper-slide>
					</swiper>
                </ul>
                <div class="search-box">
                    <input type="text" placeholder="请输入剧本名称" v-model="listPageSearchKeyWord">
                    <div class="search-btn" @click="searchScript"><van-icon name="search" /></div>
                </div>
            </div>
        </div>
        <div class="script-list-wrap" v-if="!loadMask">
            <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多啦~"
                :error.sync="error"
                error-text="请求失败  点击重新加载"
                @load="onScriptLoad"
                :offset=100
                :immediate-check="false"
            >   
				<div class="empty" v-if="scriptListArr.length==0"><img src="../assets/img/empty.png" alt=""></div>
                <van-cell class="script-list-box" v-for="(item,index) in scriptListArr" :key="index">
                    <div class="script-list-cont-box">
						<div class="exchange-tag" v-if="item&&item.cdkey"></div>
                        <router-link :to="{name:'scriptdetail',query:{id:item&&item.id,type:item&&item.type.value}}" class="script-content">
							<div class="img-box">
                                <img :src="item&&item.image" alt="">
                                <span>{{item&&item.over.name}}</span>
                            </div>
                            <div class="detail-box">
                                <p class="title">{{item&&item.title}}</p>
                                <p class="intro">{{item&&item.intro}}</p>
                                <p class="author-type"><span class="author">{{item&&item.writer_type==1?'编剧':'策划'}}：{{item&&item.writer_name}}</span><span class="type">{{item&&item.one_cateid_name}}·{{item&&item.two_cateid_name.slice(0,2).join('·')}}</span></p>
                            </div>
                        </router-link>
                    </div>
                    <div class="follow-wrap">
                        <div class="follow-box">
                        <div :class="{'follow-btn':true,'mfollow-btn':item.is_follow==1}" @click="toggleFollow($event)" :data-role=item&&item.id>
                            <!-- <span class="unfollow"></span>
                            <span class="follow"></span> -->
                        </div>
                    </div>
                    </div>
                </van-cell>
            </van-list>
        </div>
    </div>
</div>
</template>
<script>
import axios from 'axios'
import {Axios} from '@/assets/api/axios'
import {GetCookie} from '@/assets/api/cookie'
import Loading from '@/components/Loading.vue'
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import notifyIcon from '@/assets/img/msgicon.png'
export default {
    name:'ScriptList',
    data(){
        return{
            oneCateList:[],                  //一级分类列表
            twoCateList:[],                  //二级分类列表
            scriptListArr:[],                //剧本列表
            oneCateNum:'',                   //储存一级分类类别
            twoCateNum:[],                   //储存二级分类类别
            searchKeyWord:'',                //储存搜索关键字
            orderby:['time','asc'],          //按默认排序获取数据
            isAllActiveOne:true,             //全部类型全部选项选中状态
            oneActiveClass:9999,             //控制一级分类选中状态
            listPageSearchKeyWord:'',        //剧本列表页搜索关键词

            isAllActiveTwo:true,             //二级分类全部选项选中状态
            fromeHomeTagSearch:'',            //从首页点击标签跳转到列表页检索
            
            pageNum:0,                       //加载更多页码控制
            loading: false,                  //控制上划加载状态显示
            finished: false,                 //控制上划加载完成状态显示
            error: false,                    //控制上划加载出错状态显示
            curTotalScriptNum:'',            //当前页面已加载的剧本数量

            followStatus:'',                  //当前剧本关注状态

			loadMask:true,                    //控制加载页面显示隐藏
			date:new Date(),                  //定义事件对象
			curTime:'',                       //每次进入页面获取实时的时间
			ListPageSwiperOption: {
				slidesPerView: 'auto',
				spaceBetween: 9,
			}
			
        }
    },
    created(){
		//获取实时时间请求接口
		this.curTime=this.date.getFullYear()+'-'
		this.curTime=this.curTime+(this.date.getMonth()+1)+'-'
		this.curTime=this.curTime+(this.date.getDate())+' '
		this.curTime=this.curTime+(this.date.getHours())+':'
		this.curTime=this.curTime+(this.date.getMinutes())+':'
		this.curTime=this.curTime+(this.date.getSeconds())
        if(this.$route.query.kw){
			this.listPageSearchKeyWord=this.$route.query.kw
            axios.all([
                Axios.get('article/list',{params:{"orderby":this.orderby,"limitdate":this.curTime,"num":8,"search":this.$route.query.kw,"one":this.oneCateNum,"two":this.twoCateNum}}),
                Axios.get('/cate/one'),
                Axios.get('/cate/two')
            ]).then(
                axios.spread((listResponse,oneCateResponse,twoCateResponse)=>{
                    this.getScriptList(listResponse)
                    this.getOneCate(oneCateResponse)
                    this.getTwoCate(twoCateResponse)
                    this.loadMask=false
                    window.history.replaceState({},0,'scriptlist')
                })
            )
        }else{
			if(GetCookie('token')){
				Axios.defaults.headers.common['Authorization']=GetCookie('token')
			}
            //获取一级二级分类 10条剧本数据
            axios.all([
                Axios.get('article/list',{params:{"orderby":this.orderby,"limitdate":this.curTime,"num":8,"search":this.searchKeyWord,"one":this.oneCateNum,"two":this.twoCateNum}}),
                Axios.get('/cate/one'),
                Axios.get('/cate/two')
            ]).then(
                axios.spread((listResponse,oneCateResponse,twoCateResponse)=>{
                    this.getScriptList(listResponse)
                    this.getOneCate(oneCateResponse)
                    this.getTwoCate(twoCateResponse)
                    this.loadMask=false
                })
            )
        }
    },
    methods:{
        //处理一级分类数据
        getOneCate(oneCateResponse){
            if(oneCateResponse.data.code==200&&oneCateResponse.data.status=="success"){
                this.oneCateList=oneCateResponse.data.data
            }
        },
        //处理二级分类数据
        getTwoCate(twoCateResponse){
            if(twoCateResponse.data.code==200&&twoCateResponse.data.status=="success"){
                this.twoCateList=twoCateResponse.data.data
            }
        },
        getScriptList(listResponse){
            if(listResponse.data.code==200&&listResponse.data.status=="success"){
                this.scriptListArr=listResponse.data.data
                this.curTotalScriptNum=this.scriptListArr.length
                this.followStatus=listResponse.data.data.is_follow
            }
        },
        //一级分类点击全部
        allActiveOne(){
            this.finished=false
            this.isAllActiveOne=true
            this.oneActiveClass=999
            this.oneCateNum=''
            Axios.get('article/list',{params:{"orderby":this.orderby,"limitdate":this.curTime,"num":8,"search":this.searchKeyWord,"one":this.oneCateNum,"two":this.twoCateNum}})
            .then(
                response=>{
                    if(response.data.code==200&&response.data.status=="success"){
                        this.scriptListArr=response.data.data
                        this.curTotalScriptNum=this.scriptListArr.length
                    }
                }
            ).catch(
                error=>{
                    this.$swal({
						text:'网络错误请稍后重试',
						showConfirmButton:false,
						width:'6rem',
						padding:'0.5rem',
						timer:1200,
						imageWidth:50,
						imageHeight:50,
						imageUrl:notifyIcon,
						timerProgressBar: true
					})
                }
            )
        },
        //筛选一级分类
        selOnecateTag(e,index){
            this.finished=false
            this.isAllActiveOne=false
            this.oneActiveClass=index
            this.oneCateNum=e.target.dataset.role
            Axios.get('article/list',{params:{"orderby":this.orderby,"limitdate":this.curTime,"num":8,"search":this.searchKeyWord,"one":this.oneCateNum,"two":this.twoCateNum}})
            .then(
                response=>{
                    if(response.data.code==200&&response.data.status=="success"){
                        this.scriptListArr=response.data.data
                        this.curTotalScriptNum=this.scriptListArr.length
                    }
                }
            ).catch(
                error=>{
                    this.$swal({
						text:'网络错误请稍后重试',
						showConfirmButton:false,
						width:'6rem',
						padding:'0.5rem',
						timer:1200,
						imageWidth:50,
						imageHeight:50,
						imageUrl:notifyIcon,
						timerProgressBar: true
					})
                }
            )
        },
        //二级分类点击全部
        allActiveTwo(){
            this.finished=false
            //点击二级分类全部时删除其他所有二级分类标签的ACTIVE状态
            this.$refs.twoCateTag.forEach(item=>{
                item.removeAttribute("class")
            })
            this.isAllActiveTwo=true
            this.twoCateNum=[]
            Axios.get('article/list',{params:{"orderby":this.orderby,"limitdate":this.curTime,"num":8,"search":this.searchKeyWord,"one":this.oneCateNum,"two":this.twoCateNum}})
            .then(
                response=>{
                    if(response.data.code==200&&response.data.status=="success"){
                        this.scriptListArr=response.data.data
                        this.curTotalScriptNum=this.scriptListArr.length
                    }
                }
            )
        },
        //筛选二级分类
        selTwocateTag(e){
            this.finished=false
            this.isAllActiveTwo=false
            //储存二级分类检索值
            let tagRole=e.target.dataset.role;
            if(e.target.getAttribute("class")){
                e.target.removeAttribute("class")
            }else{
                e.target.setAttribute("class","one-active")
            }
            
            //点击是组织二级分类数组
            if(this.twoCateNum.length==0){
                this.twoCateNum.push(tagRole)
            }else if(this.twoCateNum.indexOf(tagRole)==-1){
                this.twoCateNum.push(tagRole)
            }else if(this.twoCateNum.indexOf(tagRole)!==-1){
                this.twoCateNum.splice(this.twoCateNum.indexOf(tagRole),1)
            }
            this.isAllActiveTwo=false
            Axios.get('article/list',{params:{"orderby":this.orderby,"limitdate":this.curTime,"num":8,"search":this.searchKeyWord,"one":this.oneCateNum,"two":this.twoCateNum}})
            .then(
                response=>{
                    if(response.data.code==200&&response.data.status=="success"){
                        this.scriptListArr=response.data.data
                        this.curTotalScriptNum=this.scriptListArr.length
                    }
                }
            )
        },
        //剧本列表页搜索
        searchScript(){
            if(this.listPageSearchKeyWord==""){
                this.$swal({
					text:'请输入搜索关键词',
					showConfirmButton:false,
					width:'6rem',
					padding:'0.5rem',
					timer:1200,
					imageWidth:50,
					imageHeight:50,
					imageUrl:notifyIcon,
					timerProgressBar: true
				})
            }else{
                Axios.get('/article/list',{params:{'search':this.listPageSearchKeyWord,'limitdate':this.curTime}})
                .then(
                    response=>{
                        if(response.data.code==200&&response.data.status=='success'){
                            if(response.data.data.length){
                                this.scriptListArr=response.data.data
                                this.$refs.twoCateTag.forEach(item=>{
                                    item.removeAttribute("class")
                                })
                                this.isAllActiveOne=true
                                this.isAllActiveTwo=true
                                this.oneActiveClass=999
                            }else{
                                this.$swal({
									text:'未搜索到相关内容',
									showConfirmButton:false,
									width:'6rem',
									padding:'0.5rem',
									timer:1200,
									imageWidth:50,
									imageHeight:50,
									imageUrl:notifyIcon,
									timerProgressBar: true
								})
                            }
                        }
                    }
                )
            }
        },
        //屏幕往上滑动时加载剧本
        onScriptLoad(){
            Axios.get('article/list',{params:{"orderby":this.orderby,"limitdate":this.curTime,"page":this.pageNum,"total":this.curTotalScriptNum,"num":8,"search":this.searchKeyWord,"one":this.oneCateNum,"two":this.twoCateNum}})
            .then(
                response=>{
                    if(response.data.code==200&&response.data.status=="success"){
                        if(response.data.data.length==0){
                            this.pageNum=0;
                            this.finished=true
                            this.loading = false
                        }else{
                            this.scriptListArr.push(...response.data.data)
                            this.curTotalScriptNum=this.scriptListArr.length
                            this.pageNum++
                            this.finished=false
                            this.loading = false
                        }
                    }
                }
            ).catch(
                error=>{
                    this.loading = false
                    this.error=true
                }
            )
        },
        //点击关注按钮切换关注状态
        toggleFollow(e){
            let target=e.currentTarget
            if(target.getAttribute('class').indexOf('mfollow-btn')!==-1){
                Axios.get('/article/unfollow/'+target.dataset.role).then(
                    response=>{
                        if(response.data.code==200&&response.data.status=="success"){
                            target.setAttribute('class','follow-btn')
                        }
                    }
                ).catch(
					error=>{
						if(error.response.data.code==422){
							this.$swal({
								text:'未登录或登录超时 请重新登录',
								showConfirmButton:false,
								width:'6rem',
								padding:'0.5rem',
								timer:1000,
								imageWidth:50,
								imageHeight:50,
								imageUrl:notifyIcon,
								timerProgressBar: true
							})
							setTimeout(()=>{
								location.href='/login'
							},1000)
						}
					}
				)
            }else if(target.getAttribute('class').indexOf('mfollow-btn')==-1){
                Axios.get('/article/follow/'+target.dataset.role).then(
                    response=>{
                        if(response.data.code==200&&response.data.status=="success"){
                           target.setAttribute('class','follow-btn  mfollow-btn')
                        }
                    }
                ).catch(
					error=>{
						if(error.response.data.code==422){
							this.$swal({
								text:'未登录或登录超时 请重新登录',
								showConfirmButton:false,
								width:'6rem',
								padding:'0.5rem',
								timer:1000,
								imageWidth:50,
								imageHeight:50,
								imageUrl:notifyIcon,
								timerProgressBar: true
							})
							setTimeout(()=>{
								location.href='/login'
							},1000)
						}
					}
				)
            }
        }
    },
    components:{
		Loading,
		swiper,
    	swiperSlide
    }
}
</script>
<style lang="scss">
.swiper-slide{
	width:66px !important;
}
.empty{
	background:#fff;
	height:280px;
	padding-top:140px;
	img{
		width:280px;
		height:280px;
		display:block;
		margin:0 auto;
	}
}
.script-list{
    width:750px;
    background:#f8f6f7;
    padding-top:88px;
    .mfollow-btn{
        background:url('../assets/img/follow.png') no-repeat !important;
        background-size:100% 100% !important;
		width:28px;
        height:24px;
    }
    .one-active{
        color:#BF0000 !important;
        font-weight:bold;
    }
    .van-loading__text{
        font-size:24px;
    }
    .search-tag-wrap{
        background:#fff;
        margin-bottom:10px;
    }
    .tag-box{
        overflow:hidden;
        padding:30px 12px;
        li{
            float:left;
            padding:20px;
            color:#999;
            font-size:26px;
        }
    }
    .one-level-tag{
        border-bottom:1px solid #F8F6F7;
    }
    .search-wrap{
        padding-bottom:30px;
    }
    .search-box{
        position:relative;
        height:64px;
        input{
            border-radius:35px;
            background:#F8F6F7;
            border:none;
            width:600px;
			height:30px;
			padding:17px 0 17px 22px;
            line-height:24px;
            position:absolute;
            left:50%;
            transform:translateX(-311px);
            color:#999;
            font-size:24px;
        }
		input::-webkit-input-placeholder{
			color: #ccc !important;
			line-height:30px;
		}
		input:-moz-placeholder{
			color: #ccc !important;
			line-height:30px;
		}
		input::-moz-placeholder{
			color: #ccc !important;
			line-height:30px;
		}
		input:-ms-input-placeholder{
			color: #ccc !important;
			line-height:30px;
		}
        .search-btn{
            position:absolute;
            right:90px;
            height:42px;
			line-height:42px;
            top:50%;
            transform:translateY(-21px);
            .van-icon-search{
                color:#999 !important;
                font-size:42px;
            }
        }
    }
    .script-list-box{
        padding:40px 24px 16px 24px;
        height:320px;
        background:#fff;
        margin-bottom:10px;
        position:relative;
		.van-cell__value{
			overflow:visible !important;
		}
		.exchange-tag{
			position:absolute;
			width:76px;
			height:80px;
			left:-24px;
			top:-40px;
			z-index:1000;
			background:url('../assets/img/exchange.png') no-repeat;
			background-size:100% 100%;
		}
        .script-list-cont-box{
            height:224px;
            border-bottom:1px solid #F8F6F7;
        }
    }
    .script-content{
        height:175px;
        padding-bottom:38px;
        border-bottom:1px solid #F8F6F7;
        .img-box,.detail-box{
            float:left;
        }
        .img-box{
            width:122px;
            height:175px;
            margin-right:30px;
            position:relative;
            img{
                width:100%;
            }
            span{
                display:inline-block;
                width:80px;
                height:26px;
                font-size:18px;
                line-height:26px;
                text-align:center;
                position:absolute;
                left:0;
                bottom:20px;
                color:#fff;
                background:rgba(0,0,0,.5);
                border-radius:0 35px 35px 0;
            }
        }
        .detail-box{
            width:547px;
            .title{
                height:34px;
                line-height:34px;
                font-size:30px;
                color:#333;
                font-weight:bold;
                margin-bottom:15px;
            }
            .intro{
                height:68px;
                color:#222;
                text-align:left;
                margin-bottom:38px;
                color:#222;
                font-size:24px;
                display: -webkit-box;
                line-height: 1.4;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            .author-type{
                height:24px;
                font-size:24px;
                color:#999;
                .type{
                    float:right;
                }
            }
        }
    }
    .follow-wrap{
        height:24px;
		width:28px;
        margin-top:12px;
        display:inline-block;
        position:absolute;
        right:0;
        bottom:0;
        .follow-box{
            width:28px;
            height:24px;
            overflow:hidden;
            .follow-btn{
                width:28px;
                height:24px;
				background:url('../assets/img/unfollow.png') no-repeat;
				background-size:100% 100%;
            }
        }
    }
}
</style>